<script setup lang="ts">
import { auth, logout } from './api'
import { useRouter } from 'vue-router'

const router = useRouter()

async function onLogout() {
  await logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <div class="app">
    <header v-if="auth.user" class="topbar">
      <div class="brand">
        <img src="/logo.svg" alt="" class="brand-logo" />
        <span class="brand-text">UroFlow</span>
      </div>
      <div class="user">
        <span class="muted">{{ auth.user.full_name || auth.user.username }}</span>
        <button @click="onLogout">Abmelden</button>
      </div>
    </header>

    <main :class="{ centered: !auth.user }">
      <router-view />
    </main>
  </div>
</template>

<style scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 28px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--color-border);
}
.brand { display: flex; align-items: center; gap: 12px; }
.brand-logo { height: 32px; width: auto; }
.brand-text {
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 500;
  color: var(--color-text);
  letter-spacing: 0.01em;
}
.user { display: flex; gap: 14px; align-items: center; }
.muted { color: var(--color-muted); font-size: 13px; }

main {
  flex: 1;
  padding: 28px;
}
main.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
</style>
